import { useEffect, useRef, useState } from "react";
import {
  Image,
  ImageBackground,
  Platform,
  Pressable,
  Text,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from "react-native";
import {
  BottomPng,
  BottomlPng,
  BottomLightUpPng,
  BottomLightDownPng,
  mainLobbyBtn,
  mainLobbyBtnDesktop,
  mainLobbyBtnActive,
  MainBtnMobile,
  BottomStripPng,
  BottomStripRightPng,
  BottomJackpot,
  JackpotCoins,
} from "../../../assets";
import { getBottomSectionButtonImageByLanguage } from "../../../assets/buttonsByLanguage";

import { vars } from "../../../utils/helpers/vars";
import { useTranslation } from "react-i18next";
import { useDevice } from "../../../utils/hooks/useDevice";
import RankingModal from "../Modals/RankingComponents/RankingModal";
import BonusGamesModal from "../Modals/BonusGamesComponents/BonusGamesModal";
import { RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLogged } from "../../../store/auth/authReducer";
import { useBonusCountdown } from "../../../utils/hooks/useBonusCountdown";
import { RootState } from "../../../store";
import { bonusInitRequest } from "../../../store/bonus/bonusActions";
import { RoomRoute } from "../Middle/RoomTablesSection";
import { isDesktop } from "@rnv/renative";
import { profileRequest } from "../../../store/auth/authActions";
import { miniGamesRewardsRequest } from "../../../store/jackpot/miniGamesRewardsActions";
import { selectMiniGamesGoldAmount } from "../../../store/jackpot/miniGamesRewardsReducer";
import { FormatWithThousandSeparator } from "../../../utils/helpers/numberFormat";

type Nav = NativeStackNavigationProp<RootStackParamList>;
type AnyRoute = RouteProp<RootStackParamList, keyof RootStackParamList>;

const BottomSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loaded = useSelector((s: RootState) => s.bonus.loaded);
  const requestedRef = useRef(false);
  useEffect(() => {
    if (requestedRef.current) return;
    if (!loaded) dispatch(profileRequest());
  }, [loaded, dispatch]);

  const [isHovered, setIsHovered] = useState(false);
  const { isClient, isXs, isSm, isMd, isLg, isPortrait } = useDevice();
  const { width, height } = useWindowDimensions();
  const isMobile = width < 500;
  const isTablet = width < 900;
  const isAndroid = Platform.OS === "android";
  const [isRankingModalOpen, setIsRankingModalOpen] = useState(false);
  const [isBonusGamesModalOpen, setIsBonusGamesModalOpen] = useState(false);
  const [isPokerTable, setIsPokerTable] = useState(false);
  const { navigate } = useNavigation<Nav>();
  const isLogged = useSelector(selectIsLogged);
  const langCode = useSelector((s: RootState) => s.i18n?.langCode ?? "en");
  const collectedAt = useSelector(
    (s: RootState) => s.auth.user?.collectedAt,
  ) as string | undefined;

  const bonusHours = useSelector((s: RootState) => s.auth.user?.bonusHours) as
    | string
    | undefined;

  const { timeText, ready } = useBonusCountdown(
    collectedAt,
    Number(bonusHours),
  );

  const goldAmount = useSelector(selectMiniGamesGoldAmount);

  useEffect(() => {
    dispatch(miniGamesRewardsRequest());
  }, [dispatch]);

  const formattedGoldAmount = FormatWithThousandSeparator(
    Math.floor(goldAmount ?? 0),
    { hideFractIfInteger: true },
  );
  const route = useRoute<AnyRoute>();

  const isTournaments =
    route.name === "Tournaments" || route.name === "Tournament";
  const isWeb = Platform.OS === "web";

  if (!isClient) return null;
  return (
    <View
      style={{
        width: "100%",
        alignItems: "center",
        // backgroundColor: "rgba(255,0,0,0.3)",

        // ...(isWeb ? { position: "absolute", bottom: 0 } : { height: 194 }), // 👈 само за web
      }}
    >
      {/* {isPortrait && isTournaments && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            paddingHorizontal: 0,
            // width: width / 2,
            // minHeight: 114,
            height: 120,
            // position: "absolute",
            bottom: 0,
            // zIndex: 5,
          }}
        >
          <TouchableOpacity
            onPress={() => {
              if (isLogged) {
                navigate("MyTables");
              } else {
                navigate("Login");
              }
            }}
          >
            <ImageBackground
              source={mainLobbyBtn}
              style={{
                flex: 1,
                aspectRatio: 2.1,
                marginRight: 0,
                width: width / 2,
              }}
              resizeMode="stretch"
            >
              <View>
                <Text
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    textShadowColor: "rgba(0, 0, 0, 0.7)",
                    textShadowOffset: { width: 1, height: 1 },
                    textShadowRadius: 2,
                    fontSize: 16,
                    marginTop: 8,

                    textAlign: "center",
                  }}
                >
                  {t("T_SITE_FOOTER_ACTIVE_TABLES")}
                </Text>
              </View>
            </ImageBackground>
          </TouchableOpacity>

          <ImageBackground
            source={MainBtnMobile}
            style={{
              flex: 1,
              aspectRatio: 2.1,
              marginLeft: 0,
            }}
            resizeMode="stretch"
          >
            <TouchableOpacity onPress={() => console.log("Ranking")}>
              <Text
                style={{
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadowColor: "rgba(0, 0, 0, 0.9)",
                  textShadowOffset: { width: 1, height: 1 },
                  textShadowRadius: 2,
                  fontSize: 16,
                  marginTop: 8,
                  textAlign: "center",
                }}
              >
                {t("T_SITE_RANKING_TOURNAMENTS")}
              </Text>
            </TouchableOpacity>
          </ImageBackground>
        </View>
      )} */}
      {!isTablet && isTournaments && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            paddingHorizontal: 0,
            maxHeight: 40,
            // minHeight: 130,
            position: "absolute",
            bottom: 0,
            marginBottom: 33,
            zIndex: 20,
          }}
        >
          <ImageBackground
            source={mainLobbyBtnDesktop}
            style={{
              flex: 1,
              aspectRatio: 3,
              marginRight: 0,
            }}
            resizeMode="stretch"
          >
            <TouchableOpacity
              onPress={() => {
                if (isLogged) {
                  navigate("MyTables");
                } else {
                  navigate("Login");
                }
              }}
            >
              <Text
                style={{
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadowColor: "rgba(0, 0, 0, 0.7)",
                  textShadowOffset: { width: 1, height: 1 },
                  textShadowRadius: 2,
                  fontSize: 18,
                  marginTop: 6,
                  textAlign: "center",
                  marginBottom: 3,
                }}
              >
                {t("T_SITE_FOOTER_ACTIVE_TABLES")}
              </Text>
            </TouchableOpacity>
          </ImageBackground>
          <View style={{ width: 426 }}></View>

          <ImageBackground
            source={mainLobbyBtnActive}
            style={{
              flex: 1,
              aspectRatio: 3,
              marginLeft: 0,
              left: -10,
            }}
            resizeMode="stretch"
          >
            <TouchableOpacity onPress={() => console.log("Ranking")}>
              <Text
                style={{
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadowColor: "rgba(0, 0, 0, 0.7)",
                  textShadowOffset: { width: 1, height: 1 },
                  textShadowRadius: 2,
                  fontSize: 18,
                  marginTop: 6,
                  textAlign: "center",
                  marginBottom: 3,
                }}
              >
                {t("T_SITE_RANKING_TOURNAMENTS")}
              </Text>
            </TouchableOpacity>
          </ImageBackground>
        </View>
      )}
      {isMobile && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            paddingHorizontal: 0,
            // width: width / 2,
            // minHeight: 114,
            // height: 200,
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            // height: mobileRowH,
            zIndex: 1,
            elevation: 1,
          }}
        >
          {isTournaments && (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                paddingHorizontal: 0,
                // width: width / 2,
                // minHeight: 114,
                // height: 200,

                zIndex: 1,
                elevation: 1,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                  height: width * 0.29,
                }}
              >
                <TouchableOpacity
                  style={{
                    width: isAndroid ? width / 2 + 10 : width / 2,
                    height: width * 0.28,
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 5,
                  }}
                  onPress={() => {
                    if (isLogged) {
                      navigate("MyTables");
                    } else {
                      navigate("Login");
                    }
                  }}
                >
                  <ImageBackground
                    source={mainLobbyBtn}
                    style={{
                      flex: 1,
                      aspectRatio: 2.1,
                      marginRight: 0,
                      width: isAndroid ? width / 2 + 10 : width / 2,
                      // height: height * 0.2,
                    }}
                    resizeMode="stretch"
                  >
                    <View>
                      <Text
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          textShadowColor: "rgba(0, 0, 0, 0.7)",
                          textShadowOffset: { width: 1, height: 1 },
                          textShadowRadius: 2,
                          fontSize: 16,
                          marginTop: 10,

                          textAlign: "center",
                        }}
                      >
                        {t("T_SITE_FOOTER_ACTIVE_TABLES")}
                      </Text>
                    </View>
                  </ImageBackground>
                </TouchableOpacity>

                <TouchableOpacity
                  style={{
                    width: isAndroid ? width / 2 + 10 : width / 2,
                    height: width * 0.28,
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 5,
                  }}
                  onPress={() => {
                    if (isLogged) {
                      navigate("Tournaments");
                    } else {
                      navigate("Login");
                    }
                  }}
                >
                  <ImageBackground
                    source={MainBtnMobile}
                    style={{
                      flex: 1,
                      aspectRatio: 2.1,
                      marginRight: 0,
                      width: isAndroid ? width / 2 + 10 : width / 2,
                      // height: height * 0.2,
                    }}
                    resizeMode="stretch"
                  >
                    <View>
                      <Text
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          textShadowColor: "rgba(0, 0, 0, 0.7)",
                          textShadowOffset: { width: 1, height: 1 },
                          textShadowRadius: 2,
                          fontSize: 16,
                          marginTop: 10,

                          textAlign: "center",
                        }}
                      >
                        {t("T_SITE_RANKING_TOURNAMENTS")}
                      </Text>
                    </View>
                  </ImageBackground>
                </TouchableOpacity>
              </View>
            </View>
          )}

          <View
            pointerEvents="box-none"
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              paddingHorizontal: 0,
              // width: width / 2,
              // minHeight: 114,
              // height: 200,
              position: "absolute",
              alignItems: "center",
              // left: 0,
              // right: 0,
              bottom: width * 0.13,
              // height: mobileRowH,
              zIndex: 1,
              elevation: 1,
            }}
          >
            <ImageBackground
              source={BottomJackpot}
              style={{
                flexDirection: "row",
                width: width,
                height: width * 0.06,
                alignItems: "flex-end",
                justifyContent: "center",
                zIndex: 1,
                // minWidth: 340,
              }}
              resizeMode="contain"
            >
              <View>
                <Text
                  style={{
                    color: "gold",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    textShadowColor: "rgba(0, 0, 0, 0.7)",
                    textShadowOffset: { width: 1, height: 1 },
                    textShadowRadius: 2,
                    fontSize: isMobile
                      ? 16
                      : isXs
                        ? 18
                        : isSm
                          ? 20
                          : isMd
                            ? 22
                            : 22,
                    marginBottom: 2,
                    textAlign: "center",
                  }}
                >
                  {t("T_Jackpot")}
                </Text>
              </View>
              <Image
                source={JackpotCoins}
                style={{
                  width: width * 0.2,
                  height: width * 0.1,
                  // marginHorizontal: 18,
                }}
                resizeMode="contain"
              />
              <View>
                <Text
                  style={{
                    color: "gold",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    textShadowColor: "rgba(0, 0, 0, 0.7)",
                    textShadowOffset: { width: 1, height: 1 },
                    textShadowRadius: 2,
                    fontSize: isMobile
                      ? 16
                      : isXs
                        ? 18
                        : isSm
                          ? 20
                          : isMd
                            ? 22
                            : 22,
                    marginBottom: 2,
                    textAlign: "center",
                  }}
                >
                  {formattedGoldAmount}
                </Text>
              </View>
            </ImageBackground>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              paddingHorizontal: 0,
              // width: width / 2,
              // minHeight: 114,
              // height: 200,
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              // height: mobileRowH,
              zIndex: 1,
              elevation: 1,
            }}
          >
            <View
              style={{
                width: width,
                // height: width * 0.2,
                display: "flex",
                alignItems: "center",
                zIndex: 10,
                elevation: 10,
              }}
            >
              <ImageBackground
                source={isMobile ? BottomPng : BottomlPng}
                style={{
                  flexDirection: "row",
                  width: isMobile ? width : 516,
                  height: isMobile ? width * 0.139 : 140,
                  alignItems: "flex-end",
                  justifyContent: "center",
                  zIndex: 1,
                  minWidth: 340,
                }}
                resizeMode="cover"
              >
                {!isAndroid && (
                  <Image
                    source={BottomLightUpPng}
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: isMobile ? 2 : 4,
                      top: isMobile ? 63 : 78,
                    }}
                  />
                )}

                {/* BUTTONS */}
                <View style={{ position: "absolute", zIndex: 40 }}>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={() => {
                        if (isLogged) {
                          navigate("Ranking");
                        } else {
                          navigate("Login");
                        }
                      }}
                    >
                      <Image
                        source={getBottomSectionButtonImageByLanguage(
                          "ranking",
                          langCode,
                        )}
                        style={{
                          width: isMobile ? width * 0.28 : 141,
                          height: isMobile ? width * 0.11 : 55,
                        }}
                      />
                    </TouchableOpacity>

                    <TouchableOpacity
                      onPress={() => {
                        if (!isLogged) {
                          navigate("Login");
                          return;
                        }

                        if (route.name === "Lobby") {
                          navigate("Main");
                        } else {
                          navigate("Lobby");
                        }
                      }}
                    >
                      <Image
                        source={getBottomSectionButtonImageByLanguage(
                          "lobby",
                          langCode,
                        )}
                        style={{
                          width: isMobile ? width * 0.28 : 136,
                          height: isMobile ? width * 0.11 : 56,
                        }}
                      />
                    </TouchableOpacity>

                    <Pressable
                      onPress={() => {
                        if (isLogged) {
                          setIsBonusGamesModalOpen(true);
                        } else {
                          navigate("Login");
                        }
                      }}
                      onHoverIn={() => setIsHovered(true)}
                      onHoverOut={() => setIsHovered(false)}
                      onPressIn={() =>
                        Platform.OS !== "web" && setIsHovered(true)
                      }
                      onPressOut={() =>
                        Platform.OS !== "web" && setIsHovered(false)
                      }
                    >
                      <View
                        style={{
                          width: isMobile ? width * 0.29 : 144,
                          height: isMobile ? width * 0.11 : 56,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {!ready ? (
                          <>
                            <View>
                              <ImageBackground
                                source={getBottomSectionButtonImageByLanguage(
                                  "bonuses",
                                  langCode,
                                )}
                                style={{
                                  width: isMobile ? width * 0.29 : 144,
                                  height: isMobile ? width * 0.11 : 56,
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                {/* {isLogged && ( */}
                                <Text
                                  style={{
                                    color: "cyan",
                                    fontWeight: "bold",
                                    fontSize: isMobile ? 12 : isMd ? 14 : 14,
                                    marginLeft: isMobile ? 34 : isMd ? 50 : 50,
                                    marginTop: isMobile ? 16 : isMd ? 16 : 16,
                                  }}
                                >
                                  {timeText}
                                </Text>
                                {/* )} */}
                              </ImageBackground>
                            </View>
                          </>
                        ) : (
                          <View>
                            <Image
                              source={getBottomSectionButtonImageByLanguage(
                                "bonusesHover",
                                langCode,
                              )}
                              style={{
                                width: isMobile ? 124 : 144,
                                height: isMobile ? 48 : 56,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            />
                          </View>
                        )}
                      </View>
                    </Pressable>
                  </View>
                </View>
                <Image
                  source={BottomLightDownPng}
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: isMobile ? 2 : 4,
                    top: isMobile ? 109 : 136,
                  }}
                />
              </ImageBackground>
            </View>
          </View>
        </View>
      )}
      {!isMobile && (
        <View
          style={{
            width: width,
            display: "flex",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <ImageBackground
            source={isMobile ? BottomPng : BottomlPng}
            style={{
              flexDirection: "row",
              width: isMobile ? width : 516,
              height: isMobile ? width * 0.24 : 140,
              alignItems: "flex-end",
              justifyContent: "center",
              zIndex: 10,
              minWidth: 340,
            }}
            resizeMode="cover"
          >
            {/* JACKPOT CONTAINER */}
            <View
              style={{
                position: "absolute",
                top: isMobile ? 28 : isXs ? 30 : isSm ? 48 : isMd ? 44 : 44,
                flexDirection: "row",
                alignItems: "center",
                marginTop: isMobile ? 0 : isXs ? 12 : 0,
              }}
            >
              {/* Jackpot text */}
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                style={{
                  color: "gold",
                  fontWeight: "bold",
                  fontSize: isMobile
                    ? 14
                    : isXs
                      ? 18
                      : isSm
                        ? 20
                        : isMd
                          ? 20
                          : 20,
                  textAlign: "left",
                  paddingLeft: isMobile
                    ? 160
                    : isXs
                      ? 170
                      : isSm
                        ? 178
                        : isMd
                          ? 194
                          : 190,
                }}
              >
                {formattedGoldAmount}
              </Text>
            </View>
            {/* Light Line Top */}
            {!isAndroid && (
              <Image
                source={BottomLightUpPng}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: 4,
                  top: isMobile ? 63 : 78,
                }}
              />
            )}

            {/* BUTTONS */}
            <View style={{ flexDirection: "row", marginTop: 58 }}>
              <TouchableOpacity
                onPress={() => {
                  if (isLogged) {
                    navigate("Ranking");
                  } else {
                    navigate("Login");
                  }
                }}
              >
                <Image
                  source={getBottomSectionButtonImageByLanguage(
                    "ranking",
                    langCode,
                  )}
                  style={{
                    width: isMobile ? width * 0.28 : 141,
                    height: isMobile ? width * 0.11 : 55,
                  }}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => {
                  if (!isLogged) {
                    navigate("Login");
                    return;
                  }

                  if (route.name === "Lobby") {
                    navigate("Main");
                  } else {
                    navigate("Lobby");
                  }
                }}
              >
                <Image
                  source={getBottomSectionButtonImageByLanguage(
                    "lobby",
                    langCode,
                  )}
                  style={{
                    width: isMobile ? width * 0.28 : 136,
                    height: isMobile ? width * 0.11 : 56,
                  }}
                />
              </TouchableOpacity>

              <Pressable
                onPress={() => {
                  if (isLogged) {
                    setIsBonusGamesModalOpen(true);
                  } else {
                    navigate("Login");
                  }
                }}
                onHoverIn={() => setIsHovered(true)}
                onHoverOut={() => setIsHovered(false)}
                onPressIn={() => Platform.OS !== "web" && setIsHovered(true)}
                onPressOut={() => Platform.OS !== "web" && setIsHovered(false)}
              >
                <View
                  style={{
                    width: isMobile ? width * 0.29 : 144,
                    height: isMobile ? width * 0.11 : 56,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {isLogged && !ready ? (
                    <>
                      <ImageBackground
                        source={getBottomSectionButtonImageByLanguage(
                          "bonuses",
                          langCode,
                        )}
                        style={{
                          width: isMobile ? width * 0.29 : 144,
                          height: isMobile ? width * 0.11 : 56,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {/* {isLogged && ( */}
                        <Text
                          style={{
                            color: "cyan",
                            fontWeight: "bold",
                            fontSize: isMobile ? 12 : isMd ? 14 : 14,
                            marginLeft: isMobile ? 34 : isMd ? 50 : 50,
                            marginTop: isMobile ? 16 : isMd ? 16 : 16,
                          }}
                        >
                          {timeText}
                        </Text>
                        {/* )} */}
                      </ImageBackground>
                    </>
                  ) : (
                    <Image
                      source={getBottomSectionButtonImageByLanguage(
                        "bonusesHover",
                        langCode,
                      )}
                      style={{
                        width: isMobile ? 124 : 144,
                        height: isMobile ? 48 : 56,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    />
                  )}
                </View>
              </Pressable>
            </View>

            <Image
              source={BottomLightDownPng}
              style={{
                position: "absolute",
                width: "100%",
                height: 4,
                top: isMobile ? 109 : 136,
              }}
            />

            {/* {isRankingModalOpen && (
            <RankingModal onClose={() => setIsRankingModalOpen(false)} />
          )} */}
          </ImageBackground>

          {/* <div
          style={{
            // backgroundColor: " #1d2028",
            backgroundImage: `url(${BottomStripPng})`,
            backgroundRepeat: "repeat-x",
            backgroundSize: "auto 100%",
            width: "100%",
            height: isMobile ? 22 : 33,
            position: "absolute",
            bottom: 0,
            zIndex: 1,
          }}
        /> */}
          <View
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              height: isMobile ? 22 : 33,
              zIndex: 1,
              flexDirection: "row",
            }}
          >
            {/* LEFT REPEATABLE STRIP */}
            <ImageBackground
              source={BottomStripRightPng}
              resizeMode="repeat"
              style={{ flex: 1, height: "100%" }}
            />

            {/* CENTER SPACER */}
            <View
              style={{
                width: isMobile ? "100%" : 516,
                height: "100%",
                minWidth: 350,
              }}
            />

            {/* RIGHT REPEATABLE STRIP */}
            <ImageBackground
              source={BottomStripPng}
              resizeMode="repeat"
              style={{ flex: 1, height: "100%" }}
            />
          </View>
        </View>
      )}
      {isBonusGamesModalOpen && (
        <BonusGamesModal onClose={() => setIsBonusGamesModalOpen(false)} />
      )}
    </View>
  );
};

export default BottomSection;
